export enum Module {
    Glossary,
    Hyperlinks,
    Reports,
    ReportTemplates,
    SummaryReports,
    Organisation,
    CascadedReporting,
    Mailing,
    Faq
}
